import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=02073f00&scoped=true"
import script from "./customerDetail.vue?vue&type=script&lang=js"
export * from "./customerDetail.vue?vue&type=script&lang=js"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=02073f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02073f00",
  null
  
)

export default component.exports